import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, poListData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(poListData),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Purchase Order and Bill Report',
            }
        }

        pushIntoTable(doc, poListData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (poListData) => {
        return [
            {
                text: 'Purchase Order and Bill Report',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '5%', '12%', '12%', '12%', '12%', '12%', '15%', '15%' ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, poListData) => {
        const tableItems = poListData.data;
        const tableHeader = getTableHeader();
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item,i) => {
            const rowData = getRowData(item,i);
            return doc.content[1].table.body.push(rowData);
        });

        const getLastRow = getTotal(poListData.total)
        doc.content[1].table.body.push(getLastRow);

    }

    const getTableHeader = () => {
        return [
                {text: 'SL#'},
                {text: 'PO No'},
                {text: 'PO Date'},
                {text: 'Supplier'},
                {text: 'Bill Number'},
                {text: 'Bill Date'},
                {text: 'Order Amount', alignment: 'right'},
                {text: 'Bill Amount', alignment: 'right'},
            ];
    }
    const getRowData = (item,i) => {
        let tableRow = [];

            tableRow = [
                {text: i + 1},
                {text: item.po_number},
                {text: item.date},
                {text: item.contact_profile.full_name || ''},
                {text: item.pm_bill_number},
                {text: item.pm_date},
                {text: commaFormat(item.total_order_amount), alignment: 'right'},
                {text: commaFormat(item.total_bill_amount), alignment: 'right'},
            ];
        return tableRow
    }

    const getTotal = (totalValue) => {

       return [
            {
                text: 'Total',
                alignment: 'right',
                colSpan:6,
            },
            '','','','','',
           {
               text: totalValue.total_order_amount,
               alignment: 'right'
           },

           {
               text: totalValue.total_bill_amount,
               alignment: 'right'
           },
        ]
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;